(() => {
  document.addEventListener('fennext:variant', (event) => {
    const id = String(event.detail?.id || '');
    document.querySelectorAll('.velvet-scenes').forEach((group) => {
      const figures = Array.from(group.querySelectorAll('[data-velvet-variant]'));
      if (!figures.some((figure) => figure.dataset.velvetVariant === id)) return;
      figures.forEach((figure) => { figure.hidden = figure.dataset.velvetVariant !== id; });
    });
  });
})();
